import { Box, Collapse, Grid, Link, Typography } from "@mui/material";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import CloseIcon from "@mui/icons-material/Close";
import SignInResponsiveDialog from "../uiElements/dialog/signInResponsiveDialog";
import SignUpScreen from "src/screens/outerScreens/signup/signUpScreen";

const GetSignUpOffer = () => {
  const isLoggedIn = !!sessionStorage.getItem("Token");
  const [signupOffer, setSignupOffer] = useState(true);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  
    const handleDeleteDialogOpen = () => {
      setDeleteDialogOpen(true);
    };
  
    const handleDeleteDialogClose = () => {
      setDeleteDialogOpen(false);
    };

  return (
    <>
    <Collapse in={signupOffer} timeout={400}>
      <Box
        sx={{
          background: "#6A0DAD",
          color: "#fff",
          justifyContent: "space-between",
          display: "flex",
          flexDirection: "row",
          padding: "10px 20px",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            margin: "0px",
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
              xl: "block",
            },
          }}
        >
          <Typography
            sx={{ fontFamily: "Poppins", fontWeight: 400, fontSize: "16px" }}
          >
            Call us : +91 8856-04-2557{" "}
          </Typography>
        </Box>
        <Box>
          {!isLoggedIn ? (
            <Typography
            sx={{
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: "16px",
              color: "#000",
            }}
          >
            Sign up and <span style={{ color: "#fff" }}>GET 25% OFF</span> for
            your first order.{" "}
            <Link
              href="/"
              onClick={(e) => {
                      e.preventDefault();
                      handleDeleteDialogOpen();
                    }}
              sx={{ color: "#fff", textDecoration: "underline", "&:hover":{textDecoration:'none',} }}
            >
              Sign Up Now
            </Link>
          </Typography>
          ):(
            <Typography
            sx={{
              fontFamily: "Poppins",
              fontWeight: 400,
              fontSize: "16px",
              color: "#000",
            }}
          >
            <span style={{ color: "#fff" }}>GET 25% OFF</span> for
            your first order.{" "}
          </Typography>
          )}
          
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              gap: "2px",
              alignItems: "center",
              display: {
                xs: "none",
                sm: "none",
                md: "block",
                lg: "block",
                xl: "block",
              },
            }}
          >
            <Link
              href=""
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              // target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} style={{ fontSize: "22px" }} />
            </Link>

            <Link
              href="https://api.whatsapp.com/send?phone=918856042557"
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp} style={{ fontSize: "22px" }} />
            </Link>

            <Link
              href=""
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              // target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedin} style={{ fontSize: "22px" }} />
            </Link>

            <Link
              href="https://instagram.com/TheKnockoutCulture"
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                style={{ fontSize: "22px" }}
              />
            </Link>

            <Link
              href="https://www.youtube.com/channel/UCoL4PVeYZGevMmQ4mYepuSQ"
              sx={{
                color: "#fff",
                textDecoration: "none",
                "&:hover": { color: "#FECC00", textDecoration: "none" },
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faYoutube} style={{ fontSize: "22px" }} />
            </Link>
          </Box>
          <CloseIcon
            onClick={() => setSignupOffer(false)}
            sx={{ fontSize: 26, cursor: "pointer", marginLeft: "20px" }}
          />
        </Box>
      </Box>
    </Collapse>
    <SignInResponsiveDialog
            open={isDeleteDialogOpen}
            handleClose={handleDeleteDialogClose}
          >
            <>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  order={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }}
                >
                  <img
                    src="/login_img.jpg"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  order={{ xs: 1, sm: 1, md: 1, lg: 2, xl: 2 }}
                >
                  <SignUpScreen/>
                </Grid>
              </Grid>
            </>
          </SignInResponsiveDialog>
    </>
  );
};

export default GetSignUpOffer;
